import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { PlanCard } from "../components/PlanCard";
import { Reveal } from "../components/Reveal";
import { ComplianceBanner } from "../components/ComplianceBanner";
import { CTASection } from "../components/Sections";
import { PLANS } from "../data/plans";

export default function Plans() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("plansPage.overline")}
        title={<>{t("plansPage.titleA")} <span className="text-gradient-gold">{t("plansPage.titleAccent")}</span></>}
        subtitle={t("plansPage.subtitle")}
        accent="gold"
        testId="plans-hero"
      />

      <section className="py-16 md:py-20">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {PLANS.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.06}><PlanCard plan={p} /></Reveal>
            ))}
          </div>
          <Reveal>
            <div className="mt-10"><ComplianceBanner text={t("plansPage.banner")} /></div>
          </Reveal>
        </div>
      </section>

      <CTASection title={t("plansPage.ctaTitle")} subtitle={t("plansPage.ctaSub")} ctaLabel={t("common.getQuote")} ctaTo="/quote" testId="plans-cta" />
    </>
  );
}
